// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
}

.heading {
  color: rgba(255, 255, 255, 0.9) !important;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7);
  font-size: 3rem;
  margin-bottom: 20px;
}

.subheading {
  color: rgba(255, 255, 255, 0.9) !important;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7) !important ;
  font-size: 1.5rem;
  margin-bottom: 20px;
}

.spacing-small {
  height: 30px;
}
.spacing-large {
  height: 50px;
}

.MuiOutlinedInput-root {
  font-size: 14px !important;
  color: black !important;
  font-weight: bold !important;
}

.search-box {
  width: 750px;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(10px);

  border-radius: 15px;
  border: 2px solid rgba(128, 128, 128, 0.7);
  outline: none;
  transition: all 0.3s ease-in-out;
}

.search-box .MuiOutlinedInput-notchedOutline {
  border-color: rgba(128, 128, 128, 0.7) !important;
  border-radius: 15px;
}

.search-box:hover .MuiOutlinedInput-notchedOutline {
  border-color: rgba(128, 128, 128, 0.9) !important;
  border-radius: 15px;
}

.search-box .Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: rgba(128, 128, 128, 0.9) !important;
  box-shadow: 0 0 10px rgba(128, 128, 128, 0.5) !important;
  border-radius: 15px;
}

@media (max-width: 1024px) {
  .heading {
    font-size: 2.5rem;
  }
  .subheading {
    font-size: 1.3rem;
  }
  .search-box {
    width: 70%;
  }
}

@media (max-width: 768px) {
  .heading {
    font-size: 2rem;
  }
  .subheading {
    font-size: 1.2rem;
  }
  .search-box {
    width: 90%;
  }
}

@media (max-width: 480px) {
  .heading {
    font-size: 1.8rem;
  }
  .subheading {
    font-size: 1rem;
  }
  .search-box {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/searchbox.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,uDAAuD;EACvD,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qDAAqD;EACrD,2BAA2B;;EAE3B,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;EACjD,wDAAwD;EACxD,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 20px;\n}\n\n.heading {\n  color: rgba(255, 255, 255, 0.9) !important;\n  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7);\n  font-size: 3rem;\n  margin-bottom: 20px;\n}\n\n.subheading {\n  color: rgba(255, 255, 255, 0.9) !important;\n  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7) !important ;\n  font-size: 1.5rem;\n  margin-bottom: 20px;\n}\n\n.spacing-small {\n  height: 30px;\n}\n.spacing-large {\n  height: 50px;\n}\n\n.MuiOutlinedInput-root {\n  font-size: 14px !important;\n  color: black !important;\n  font-weight: bold !important;\n}\n\n.search-box {\n  width: 750px;\n  padding: 10px;\n  background-color: rgba(255, 255, 255, 0.7) !important;\n  backdrop-filter: blur(10px);\n\n  border-radius: 15px;\n  border: 2px solid rgba(128, 128, 128, 0.7);\n  outline: none;\n  transition: all 0.3s ease-in-out;\n}\n\n.search-box .MuiOutlinedInput-notchedOutline {\n  border-color: rgba(128, 128, 128, 0.7) !important;\n  border-radius: 15px;\n}\n\n.search-box:hover .MuiOutlinedInput-notchedOutline {\n  border-color: rgba(128, 128, 128, 0.9) !important;\n  border-radius: 15px;\n}\n\n.search-box .Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: rgba(128, 128, 128, 0.9) !important;\n  box-shadow: 0 0 10px rgba(128, 128, 128, 0.5) !important;\n  border-radius: 15px;\n}\n\n@media (max-width: 1024px) {\n  .heading {\n    font-size: 2.5rem;\n  }\n  .subheading {\n    font-size: 1.3rem;\n  }\n  .search-box {\n    width: 70%;\n  }\n}\n\n@media (max-width: 768px) {\n  .heading {\n    font-size: 2rem;\n  }\n  .subheading {\n    font-size: 1.2rem;\n  }\n  .search-box {\n    width: 90%;\n  }\n}\n\n@media (max-width: 480px) {\n  .heading {\n    font-size: 1.8rem;\n  }\n  .subheading {\n    font-size: 1rem;\n  }\n  .search-box {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
